module.exports = __webpack_public_path__ + "static/media/subtitle_tag.afd315c7.svg";